<div class="d-flex align-item-center justify-content-between border_10">
  <div class="flex-grow-1 px-0" [ngClass]="floatLable ? 'input_container' : 'd-flex flex-column-reverse '">
    <input  ngx-gp-autocomplete type="text"
      [class.value-field]="address && address.length" 
      #addressItem [(ngModel)]="address" [options]='options' (onAddressChange)="handleAddressChange($event);address=''"
      [disabled]="disabled" [ngClass]="comp_class" [ngClass]="!showLabel ? 'pt-3 pb-4' : ''" class="input_field w-100 google-zip-code" autocomplete="false"
      [placeholder]="floatLable ? '' : 'Address'" required="false" id="google_zip" [readonly]="disableField"  (input)="getAddress($event)"/>
    <label for="" [ngClass]="floatLable ? 'input_label' : 'fs-14 fw-400 m-0 address-label'" >{{labelText ? labelText : (showLabel ?
      'Address' : '')}}</label>
  </div>
</div>